import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

const rootRouteRef = createRouteRef({
  id: "announcements"
});
const announcementCreateRouteRef = createSubRouteRef({
  id: "announcements/create",
  path: "/create",
  parent: rootRouteRef
});
const announcementEditRouteRef = createSubRouteRef({
  id: "announcements/edit",
  path: "/edit/:id",
  parent: rootRouteRef
});
const announcementViewRouteRef = createSubRouteRef({
  id: "announcements/view",
  path: "/view/:id",
  parent: rootRouteRef
});
const categoriesListRouteRef = createSubRouteRef({
  id: "announcements/categories",
  path: "/categories",
  parent: rootRouteRef
});

export { announcementCreateRouteRef, announcementEditRouteRef, announcementViewRouteRef, categoriesListRouteRef, rootRouteRef };
//# sourceMappingURL=routes.esm.js.map
